import React from "react";
import { GlowingIcon } from "../../UI/GlowingIcon";
import styles from "./IconsList.module.scss";
import { IColor } from "../../UI/ColoredInfoBlock/ColoredInfoBlock.types";

export interface ItemProps {
    iconName: string;
    text: string;
    iconColor?: IColor;
    textColor?: string;
    style?: React.CSSProperties;
}

const IconsItem: React.FC<ItemProps> = ({ iconName, text, iconColor, textColor = "", style }) => {
    return (
        <li className={[styles.advItem].join(" ")} style={{ ...style }}>
            <GlowingIcon name={iconName} className={styles.icon} color={iconColor} />
            <span className={styles[textColor]}>{text}</span>
        </li>
    );
};

export default IconsItem;
